import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModalComponent } from "../../../modal/modal.component";
import { InicioService } from '../../../../services/inicio.service';
import { UsuarioService } from '../../../../services/usuario.service';
import { I18n, CustomDatepickerI18n } from '../../../../clases/idioma-fecha';
import { appsettings } from '../../../../settings/appsettings';

@Component({
  selector: 'app-agregar',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, NgbDatepickerModule, NgxMaskDirective, ReactiveFormsModule],
  templateUrl: './agregar.component.html',
  styleUrl: './agregar.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class AgregarComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() vuelve = new EventEmitter<any>();
  @Input() id_rol?: any;
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';
  edad: number = 0;

  txtComponente: string = 'Cargar .PDF';
  txtSintesis: string = 'Cargar .PDF';
  txtCedula: string = 'Cargar .PDF';

  valComponente: SafeResourceUrl | null = null;
  valSintesis: SafeResourceUrl | null = null;
  valCedula: SafeResourceUrl | null = null;

  validaTipoRol: boolean = true;
  rol: any = [];
  tipo_formador: any = [];
  gerencias: any = [];
  cargo: any = [];
  sexo: any = [];
  estado_civil: any = [];
  grado_instruccion: any = [];
  estado: any = [];
  operadora_movil: any = [];
  archivos_pdf: any = [];


  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);
  private sanitizer = inject(DomSanitizer);
  private fb = inject(FormBuilder)
  private url = appsettings.apiUrl;

  formularioRegistro: FormGroup;


  constructor( ){
    this.formularioRegistro = this.fb.group({
      //---- datos_institucional ----
      frm_id_rol: ['', Validators.required],
      frm_id_tipo_formador: [''],
      frm_contrasena: [''],
      frm_confirma_contrasena: [''],
      frm_id_gerencia: ['',Validators.required],
      frm_id_cargo: ['',Validators.required],
      frm_fecha_ingreso: ['', Validators.required],
      frm_correo: ['', Validators.required],
      //---- datos_personales ----
      frm_nombre: ['', Validators.required],
      frm_apellido: ['', Validators.required],
      frm_nro_doc: [''],//
      frm_identificacion: ['', Validators.required],
      frm_fecha_nacimiento: [''],//
      frm_nivel_academico: ['', Validators.required],
      frm_edo_civil: ['', Validators.required],
      frm_genero: ['', Validators.required],
      frm_carnet_patria: [''],//
      //---- datos_contacto ----
      frm_telefono: ['', Validators.required],
      frm_correo_alternativo: ['', Validators.required],
      frm_estado: ['', Validators.required],
      frm_dirreccion: ['', Validators.required],
    });
  }


  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.seleccionarInstitucional('0').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.rol = rs.data.rol;
        this.tipo_formador = rs.data.tipo_formador;
        this.gerencias = rs.data.gerencias;
        this.cargo = rs.data.cargo;
        this.sexo = rs.data.sexo;
        this.estado_civil = rs.data.estado_civil;
        this.grado_instruccion = rs.data.grado_instruccion;
        this.estado = rs.data.estado;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  valida(eve: any){
    this.validaTipoRol = eve.value == 11 ? true : false;
  }

  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  convierteDtpick(date: string):NgbDateStruct {
    let array = date.split("-");
    return {year: parseInt(array[2]), month: parseInt(array[1]), day: parseInt(array[0])};
  }

  calcula_edad(){
    const fch_nac = this.formularioRegistro.get('frm_fecha_nacimiento')?.value;
    let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
    let fecha1 = new Date(fch);
    let fecha2 = new Date()
    let resta = fecha2.getTime() - fecha1.getTime()
    this.edad = (Math.ceil((Math.round(resta/ (1000*60*60*24)))/365))-1;
  }

  ver_pass(tipo: number){
    let pass = tipo == 1 ? (document.getElementById('contrasena') as HTMLInputElement) : (document.getElementById('confirma_contrasena') as HTMLInputElement);
    pass.getAttribute('type') == 'password' ? pass.setAttribute('type', 'text') : pass.setAttribute('type', 'password');
  }

  convertidor(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }

  cambia(tipo: number, event: any){
    const input = event.target as HTMLInputElement;
    if(tipo == 1){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          // 1. Crear la URL del objeto
          //this.rawObjectUrl = URL.createObjectURL(input.files[0]);
          // 2. Sanitizar la URL para que Angular la considere segura
          // Para iframes, usamos bypassSecurityTrustResourceUrl
          this.valComponente = this.transform(URL.createObjectURL(input.files[0]));
          this.txtComponente = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('frm_identificacion')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }
          // Paso 1: Comprobar si existe el objeto 'componente'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('componente'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'componente' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('componente'));
            this.archivos_pdf?.push({componente: envio});
          } else {
            console.log("El objeto 'componente' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({componente: envio});
          }
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          console.log('datos a enviar componente:   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 2){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valSintesis = this.transform(URL.createObjectURL(input.files[0]));
          this.txtSintesis = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('frm_identificacion')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }
          // Paso 1: Comprobar si existe el objeto 'sintesis'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('sintesis'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'sintesis' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('sintesis'));
            this.archivos_pdf?.push({sintesis: envio});
          } else {
            console.log("El objeto 'sintesis' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({sintesis: envio});
          }
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          console.log('datos a enviar sintesis:   ', envio);
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 3){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCedula = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCedula = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });
          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('frm_identificacion')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }
          // Paso 1: Comprobar si existe el objeto 'cedula'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('cedula'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'cedula' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('cedula'));
            this.archivos_pdf?.push({cedula: envio});
          } else {
            console.log("El objeto 'cedula' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({cedula: envio});
          }
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          console.log('datos a enviar cedula:   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }

  }

  guardar_todo(){
    let passRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)(?=.*[a-z]).{8,}$/;
    let pass = this.formularioRegistro.get('frm_contrasena')?.getRawValue();
    let valor: boolean = true;
    if(!this.formularioRegistro.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario (*)";
      this.mdl.alerta();
      valor = false;
    }
    else if(pass != '' || this.formularioRegistro.get('frm_confirma_contrasena')?.getRawValue() != ''){
      if(!passRegex.test(pass)){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        //this.mensaje = "La contraseña no cumple con las características de validación. Por favor presione el botón de ('Indicaciones para crear la contraseña...') ";
        this.mensaje = "La contraseña no cumple con las características de validación.";
        this.mdl.alerta();
        valor = false;
      }else if(pass != this.formularioRegistro.get('frm_confirma_contrasena')?.getRawValue()){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = "Las contraseñas deben ser iguales";
        this.mdl.alerta();
        valor = false;
      }
      else{
        valor = true;
      }
    }
    else{
      valor = true;
    }
    if(valor){
      //aplica solo caundo se va a enviar en vista de que si no se ejecuta el
      //servicio da error ya que modificamos las variables del formGroup
      let fch_nac = this.formularioRegistro.get('frm_fecha_nacimiento')?.getRawValue();
      let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
      let fch_ing = this.formularioRegistro.get('frm_fecha_ingreso')?.getRawValue();
      let fch2 = `${this.convertidor(fch_ing['year'])}-${this.convertidor(fch_ing['month'])}-${this.convertidor(fch_ing['day'])}`
      this.formularioRegistro.get('frm_fecha_nacimiento')?.setValue(fch);
      this.formularioRegistro.get('frm_fecha_ingreso')?.setValue(fch2);
      console.log('todos: ', this.formularioRegistro.value);
      console.log('datos archivos', this.archivos_pdf);
      console.log('edad', this.edad);
      this.mdl.cargando();
      this.servicios.insertInstitucional(this.formularioRegistro.value).subscribe({
        next: (rs) => {
          console.log('datos llegada: ',rs.data)
          this.archivos_pdf.forEach((dt:any) => {
            if(dt.hasOwnProperty('componente'))this.subir_archivo(dt['componente']);
            if(dt.hasOwnProperty('sintesis'))this.subir_archivo(dt['sintesis']);
            if(dt.hasOwnProperty('cedula'))this.subir_archivo(dt['cedula']);
          });
          this.mdl.cerrar();
          this.vuelve.emit({value: false, validador: true});
        },
        error: (error) => {
          this.mdl.cerrar();
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = error.message;
          this.mdl.alerta();
        }
      });
    }
  }

  subir_archivo(datos: any){
    this.servicios.subir_archivo_institucional(datos).subscribe({
      next: (rs) => {
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  volver(){
    this.vuelve.emit({value: false, validador: false});
  }

}
